import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeFinish", "taskKey"];
import UITourFinishButton from 'ui-shepherd-react/button/UITourFinishButton';
import { openTaskCompletionModal } from '../util/banner';
import { jsx as _jsx } from "react/jsx-runtime";
const OnboardingTourFinishButton = props => {
  const {
      beforeFinish,
      taskKey
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UITourFinishButton, Object.assign({
    beforeFinish: ({
      tourKey,
      stepKey
    }) => {
      if (taskKey) {
        openTaskCompletionModal(taskKey);
      }
      if (typeof beforeFinish === 'function') {
        return beforeFinish(tourKey, stepKey);
      }
      return undefined;
    }
  }, buttonProps));
};
export default OnboardingTourFinishButton;